/**
 * Created by david.vanoni@coplex.com on 12/29/17.
 */

import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { initiativeParticipation as initiativeParticipationSchema } from '../lib/schema.js';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { selectEntities } from './entities.js';

// API Actions
const UPDATE_PARTICIPATION_REQUEST =
  'changesync/initiativeParticipations/UPDATE_PARTICIPATION_REQUEST';
const UPDATE_PARTICIPATION_SUCCESS =
  'changesync/initiativeParticipations/UPDATE_PARTICIPATION_SUCCESS';
const UPDATE_PARTICIPATION_FAILURE =
  'changesync/initiativeParticipations/UPDATE_PARTICIPATION_FAILURE';

// Action Creators

export const updateInitiativeParticipation = (id, initiativeParticipation) => ({
  [CALL_API]: {
    types: [
      UPDATE_PARTICIPATION_REQUEST,
      UPDATE_PARTICIPATION_SUCCESS,
      UPDATE_PARTICIPATION_FAILURE,
    ],
    endpoint: `initiative_participations/${id}`,
    method: HTTP_METHODS.PUT,
    body: {
      initiativeParticipation,
    },
    schema: initiativeParticipationSchema,
  },
});

// Selectors
export const selectInitiativeParticipation = (id) =>
  createSelector(selectEntities, (entities) =>
    denormalize(id, initiativeParticipationSchema, entities)
  );
